import C,{useState,useRef,useMemo}from'react';import {jsxs,Fragment,jsx}from'react/jsx-runtime';var W=Object.create;var S=Object.defineProperty;var Y=Object.getOwnPropertyDescriptor;var $=Object.getOwnPropertyNames;var q=Object.getPrototypeOf,J=Object.prototype.hasOwnProperty;var G=(t,o)=>()=>(o||t((o={exports:{}}).exports,o),o.exports);var K=(t,o,r,n)=>{if(o&&typeof o=="object"||typeof o=="function")for(let e of $(o))!J.call(t,e)&&e!==r&&S(t,e,{get:()=>o[e],enumerable:!(n=Y(o,e))||n.enumerable});return t};var Q=(t,o,r)=>(r=t!=null?W(q(t)):{},K(!t||!t.__esModule?S(r,"default",{value:t,enumerable:true}):r,t));var k=G((uo,h)=>{(function(){var t={}.hasOwnProperty;function o(){for(var e="",i=0;i<arguments.length;i++){var s=arguments[i];s&&(e=n(e,r(s)));}return e}function r(e){if(typeof e=="string"||typeof e=="number")return e;if(typeof e!="object")return "";if(Array.isArray(e))return o.apply(null,e);if(e.toString!==Object.prototype.toString&&!e.toString.toString().includes("[native code]"))return e.toString();var i="";for(var s in e)t.call(e,s)&&e[s]&&(i=n(i,s));return i}function n(e,i){return i?e?e+" "+i:e+i:e}typeof h<"u"&&h.exports?(o.default=o,h.exports=o):typeof define=="function"&&typeof define.amd=="object"&&define.amd?define("classnames",[],function(){return o}):window.classNames=o;})();});var R=Q(k());var E="6eaeb6e22dbc481858e021a83d8ea3c934a8adb11c3b7faff0ff429ae15aa73f",X=`._container_18f8u_1 {
	--brand-color: #744ed4;
	--brand-color-dark: #5629c6;
	--color-text-primary: #111111;
	--color-text-primary-inverted: #fff;
	--color-text-link: var(--brand-color);
	--size-large: 24px;
	--size-medium: 16px;
	--size-small: 12px;
	--size-xSmall: 8px;

	--color-white: #fff;
	--color-gray-100: hsla(0, 0%, 93.7%, 0.49019607843137253);
	--color-gray-200: #f2f2f2;
	--color-gray-300: #eaeaea;
	--color-gray-400: #bdbdbd;
	--color-gray-500: #828282;
	--color-gray-600: #7e7e7e;
	--color-gray-700: #8a8f98;
	--color-gray-800: #2d2f36;

	--font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI',
		Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
		'Segoe UI Emoji', 'Segoe UI Symbol';

	background: hsl(0deg 0% 0% / 75%);
	font-family: var(--font-family);
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 999999;
	backdrop-filter: blur(1px);
	display: flex;
	justify-content: center;
	align-items: center;
}

@media only screen and (max-width: 420px) {
	._card_18f8u_41 {
		max-width: 100vw !important;
		height: 100%;
		border-radius: 0;
	}

	._cardContents_18f8u_47 {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	._form_18f8u_53 {
		height: 100%;
	}

	._textareaLabel_18f8u_57 {
		flex: 1;
	}

	._form_18f8u_53 textarea {
		height: 100%;
	}

	._ad_18f8u_65 {
		display: none;
	}
}

._card_18f8u_41 {
	border-radius: var(--size-xSmall);
	padding: 20px;
	width: 420px;
	max-width: calc(100vw - 1rem);
	background: white;
}

._title_18f8u_78 {
	font-size: 20px;
	color: var(--color-text-primary);
}

._subtitle_18f8u_83 {
	font-size: 13px;
	margin-top: var(--size-medium) !important;
	font-weight: 400;
	color: #8c8b92;
}

._form_18f8u_53 {
	padding-top: var(--size-large);
	display: flex;
	flex-direction: column;
	gap: var(--size-small);
	width: 100%;
}

._form_18f8u_53 label {
	display: flex;
	flex-direction: column;
	font-size: 11px !important;
	font-weight: 500;
	color: var(--color-gray-500);
}

._form_18f8u_53 input {
	height: 28px;
}

._form_18f8u_53 textarea {
	font-family: var(--font-family);
	min-height: 80px;
}

._form_18f8u_53 input,
._form_18f8u_53 textarea {
	background-color: var(--color-white);
	border: 1px solid #dcdbdd;
	border-radius: 6px;
	color: var(--color-gray-500);

	font-size: 13px;
	margin: 8px 0;
	outline: none;
	padding: 4px 6px;
	width: calc(100%);
}

._form_18f8u_53 button {
	align-items: center;
	display: flex;
	justify-content: center;
	height: auto;
	color: var(--color-text-primary-inverted);
	background-color: var(--brand-color);
	text-shadow: none;
	box-shadow: none;
	padding: 4px 6px;
	font-size: 14px;
	border-radius: 6px;
	border: 0;
	cursor: pointer;
}

._form_18f8u_53 button:hover {
	background-color: var(--brand-color-dark);
}

._form_18f8u_53 button[disabled] {
	opacity: 0.5;
	pointer-events: none;
}

._form_18f8u_53 ._closeButton_18f8u_154 {
	background-color: transparent;
	color: #6f6e77 !important;
	font-size: 13px;
	font-family: var(--font-family);
	border: 1px solid var(--color-white);
}

._form_18f8u_53 ._closeButton_18f8u_154:hover {
	background-color: var(--color-gray-100);
	border-color: var(--color-gray-300);
}

._confirmationButton_18f8u_167 {
	float: right;
	margin-top: 3rem;
}

._formFooter_18f8u_172 {
	display: flex;
	flex-direction: row-reverse;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
}

._formActionsContainer_18f8u_180 {
	display: flex;
	flex-direction: row-reverse;
	gap: 6px;
}

._ad_18f8u_65:hover {
	background-color: var(--color-gray-100);
}

._logoContainer_18f8u_190 {
	display: flex;
	align-items: center;
	gap: 6px;

	border: 1px solid var(--color-gray-300);
	border-radius: 6px;
	color: var(--color-gray-500);
	font-size: 13px;
	padding: 4px 8px;
}

._logo_18f8u_190 {
	height: 16px;
}

._buggyButton_18f8u_206 {
	align-items: center;
	background: #5629c6;
	border-radius: 8px;
	border: 1px solid #bdbdbd;
	box-shadow: none;
	color: #fff;
	cursor: pointer;
	display: flex;
	font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI',
		Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
		'Segoe UI Emoji', 'Segoe UI Symbol';
	font-size: 14px;
	height: auto;
	justify-content: center;
	min-height: 40px;
	padding: 4px 16px;
	text-shadow: none;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(E)){var t=document.createElement("style");t.id=E,t.textContent=X,document.head.appendChild(t);}})();var a={container:"_container_18f8u_1",card:"_card_18f8u_41",cardContents:"_cardContents_18f8u_47",form:"_form_18f8u_53",textareaLabel:"_textareaLabel_18f8u_57",ad:"_ad_18f8u_65",title:"_title_18f8u_78",subtitle:"_subtitle_18f8u_83",closeButton:"_closeButton_18f8u_154",confirmationButton:"_confirmationButton_18f8u_167",formFooter:"_formFooter_18f8u_172",formActionsContainer:"_formActionsContainer_18f8u_180",logoContainer:"_logoContainer_18f8u_190",logo:"_logo_18f8u_190"};function b({labelClose:t="Cancel",labelComments:o="Message",labelName:r="Name",labelEmail:n="Email",labelSubmit:e="Submit",subtitle2:i="If you\u2019d like to help, tell us what happened below.",subtitle:s="Our team has been notified.",successMessage:f="Your feedback has been sent. Thank you!",successSubtitle:I="Thank you for sending us feedback. If you have any other concerns/questions, reach out to this application's support email.",title:H="It looks like we\u2019re having issues.",placeholderComments:A="I typed in a name then clicked the button",user:y,onCloseHandler:x,onSubmitHandler:v,hideHighlightBranding:z=false,error:_}){let[p,O]=useState(y?.name||""),[m,M]=useState(y?.email||""),[g,F]=useState(""),[T,w]=useState(false),[U,j]=useState(false),L=useRef(new Date().toISOString()),P=useMemo(()=>{let d=!!m.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);return !!p&&d&&!!g},[p,m,g]);C.useEffect(()=>{window?.H?.consumeError&&_&&window.H.consumeError(_);},[_]);let V=d=>{d.preventDefault(),w(true),window?.H?.addSessionFeedback?window.H.addSessionFeedback({verbatim:g,userName:p,userEmail:m,timestampOverride:L.current}):console.warn("Highlight is not initialized. Make sure highlight.run is installed and running."),new Promise(Z=>window.setTimeout(Z,300)).then(()=>{w(false),j(true),v&&v();});};return jsxs(Fragment,{children:[jsx("style",{dangerouslySetInnerHTML:{__html:`
					@font-face {
						font-display: swap;
						font-family: 'Inter';
						font-style: normal;
						font-weight: normal;
						src: local('Inter Regular'), local('InterRegular'),
							url('https://app.highlight.io/font/Inter-Regular.woff2')
								format('woff2');
					}
					@font-face {
						font-display: swap;
						font-family: 'Inter';
						font-style: normal;
						font-weight: 500;
						src: local('Inter Medium'), local('InterMedium'),
							url('https://app.highlight.io/font/Inter-Medium.woff2')
								format('woff2');
					}

					::placeholder {
						color: var(--color-gray-300);
					}
			`}}),jsx("main",{className:a.container,children:jsx("div",{className:a.card,children:U?jsxs("div",{className:a.cardContents,children:[jsx("h1",{className:a.title,children:f}),jsx("h4",{className:a.subtitle,children:I}),jsx("div",{children:jsx("button",{className:(0, R.default)(a.button,a.confirmationButton),onClick:x,children:"Close"})})]}):jsxs("div",{className:a.cardContents,children:[jsxs("div",{children:[jsx("h1",{className:a.title,children:H}),jsxs("h2",{className:a.subtitle,children:[s," ",i]})]}),jsxs("form",{className:a.form,onSubmit:V,children:[jsxs("label",{children:[r,jsx("input",{type:"text",value:p,name:"name",autoFocus:true,onChange:d=>{O(d.target.value);},placeholder:"Tom Jerry"})]}),jsxs("label",{children:[n,jsx("input",{type:"email",value:m,name:"email",onChange:d=>{M(d.target.value);},placeholder:"mail@mail.com"})]}),jsxs("label",{className:a.textareaLabel,children:[o,jsx("textarea",{value:g,placeholder:A,name:"verbatim",rows:3,onChange:d=>{F(d.target.value);}})]}),jsxs("div",{className:a.formFooter,children:[jsxs("div",{className:a.formActionsContainer,children:[jsx("button",{type:"submit",disabled:!P||T,children:e}),jsx("button",{className:a.closeButton,onClick:x,type:"button",children:t})]}),!z&&jsx("div",{className:a.ad,children:jsx("a",{href:"https://highlight.io",target:"_blank",children:jsxs("div",{className:a.logoContainer,children:[jsx("img",{src:"https://www.highlight.io/images/logo-on-dark.png",alt:"Highlight",className:a.logo}),jsx("span",{children:"Powered by highlight.io"})]})})})]})]})]})})})]})}var D={componentStack:null,error:null,showingDialog:false},B=class extends C.Component{refs={};state=D;componentDidCatch(o,r){let{beforeCapture:n,onError:e,showDialog:i}=this.props;n&&n(o,r.componentStack??null),no(o,r),e&&e(o,r.componentStack??""),i!==false&&this.setState({...this.state,showingDialog:true}),this.setState({error:o,componentStack:r.componentStack??null});}componentDidMount(){let{onMount:o}=this.props;o&&o();}componentWillUnmount(){let{error:o,componentStack:r}=this.state,{onUnmount:n}=this.props;n&&n(o,r);}resetErrorBoundary=()=>{let{onReset:o}=this.props,{error:r,componentStack:n}=this.state;o&&o(r,n),this.setState(D);};hideDialog=()=>{this.setState({...this.state,showingDialog:false}),(this.props.onAfterReportDialogCancelHandler||(()=>{window.location.href=window.location.origin;}))();};onReportDialogSubmitHandler=()=>{this.props.onAfterReportDialogSubmitHandler&&this.props.onAfterReportDialogSubmitHandler();};render(){let{fallback:o,children:r,customDialog:n}=this.props,{error:e,componentStack:i,showingDialog:s}=this.state;if(e){let f;return typeof o=="function"?f=o({error:e,componentStack:i,resetError:this.resetErrorBoundary}):f=o,C.isValidElement(f)?jsxs(Fragment,{children:[s&&jsx(b,{...this.props.dialogOptions,onCloseHandler:this.hideDialog,onSubmitHandler:this.onReportDialogSubmitHandler}),f]}):(o&&console.warn("fallback did not produce a valid ReactElement"),s&&n?n:s&&jsx(b,{...this.props.dialogOptions,onCloseHandler:this.hideDialog,onSubmitHandler:this.onReportDialogSubmitHandler}))}return typeof r=="function"?r():r}};function no(t,o){let r=ao(o.componentStack??"");window.H?(console.error("Highlight ErrorBoundary caught an exception while rendering React component",{error:t}),window.H.consume(t,{payload:{component:r},source:r,type:"React.ErrorBoundary"})):console.warn("You need to install highlight.run.");}function ao(t){let o=t.split(`
`);if(o.length<1)return;let n=o[1].trim().split(" ");if(n.length===4)return `<${n[1]}>`}var Eo=({children:t})=>{let[o,r]=C.useState(false);if(o)throw new Error("something bad happened - this is a sample test error");return jsx("button",{type:"button",className:"buggyButton",onClick:()=>r(true),children:t??"Throw an Error"})};/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/export{B as ErrorBoundary,b as ReportDialog,Eo as SampleBuggyButton};//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map